import React from 'react'
import './p-component.scss'
import { PProps } from '../../types'
import { concatClassName } from '../../utils/helpers'

const P = ({ text, classes, variant, textSize = 'regular', dataTestId }: PProps) => {
  return (
    <p
      className={`basic ${concatClassName(classes)} ${variant} ${textSize}`}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      {' '}
      {text}{' '}
    </p>
  )
}
export { P }
